<body>
  <ul>
    <div>
      <div *ngIf="dataLoaded">
        <!-- Input fields to select the date range -->
        <input #dateInput type="date" [(ngModel)]="startDate" class="select-input">
        <input #dateInput2 type="date" [(ngModel)]="endDate" class="select-input">
        <button (click)="getItemsFromJetta()">Atualizar</button>
        <button (click)="salvar()">Salvar</button>
        <div class="progress-bar-container">
          <div class="progress-bar" [style.width]="getProgressWidth()"></div>
        </div>
        <table>
          <tr>
            <th class="blue-text">
              <a class="blue-text">Descrição da Roterização</a>
            </th>
            <th class="blue-text">
              <a class="blue-text">Data da Roterização</a>
            </th>
            <th class="blue-text">
              <a class="blue-text">Total Rotas</a>
            </th>
          </tr>
          <tr *ngFor="let item of items">
            <td>{{ item.description }}</td>
            <td>{{ item.date | date:'dd/MM/yyyy' }}</td>
            <!-- <td>{{ routes[0].length }}</td> -->
            <td>1</td>
          </tr>
          <!-- <tr>
              <th class="blue-text">
                <a class="blue-text">Veículo</a>
              </th>
              <th class="blue-text" colspan="2">
                <a class="blue-text">Placa</a>
              </th>
              <!-- <th class="blue-text">
                <a class="blue-text">Placa</a>
              </th> --
            </tr> -->

          <ng-container *ngFor="let routeArray of routes">
            <tr *ngFor="let route of routeArray">
              <td>
                <ul>
                  <li *ngFor="let transport of route.result.transports">{{ transport.descricao }}</li>
                </ul>
              </td>
              <!-- <td colspan="2">
                  <ul>
                    <li *ngFor="let transport of route.result.transports">{{ transport.plate }}</li>
                  </ul>
                </td> -->
            </tr>
          </ng-container>

        </table>
      </div>
    </div>
  </ul>
</body>

<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>